"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.object.values");
require("core-js/modules/es6.number.constructor");
var _auth = require("@/utils/auth");
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'upload',
  props: {
    limit: {
      type: Number,
      default: 1
    },
    multiple: {
      type: Boolean,
      default: false
    },
    fileList: {
      type: Array,
      default: []
    },
    ratio: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      baseURL: this.config.BASE_URL,
      dialogImageUrl: '',
      dialogVisible: false,
      percentage: 1,
      upObj: {
        token: (0, _auth.getToken)()
      },
      fileOk: {}
    };
  },
  methods: {
    /**
     * 图片上传调用接口成功 但上传不一定成功
     */
    handleSuccess: function handleSuccess(res, file, fileList) {
      if (res.data.code > 0) {
        file.status = 'error';
        this.$message.error("\u56FE\u7247\u4E0A\u4F20\u5931\u8D25:".concat(res.data.message, ", \u8BF7\u5220\u9664\u5931\u8D25\u7684\u56FE\u7247\u91CD\u65B0\u4E0A\u4F20"));
      } else {
        this.fileOk[file.uid] = res.data.file_url;
        this.update();
      }
    },
    /**
     * 移除图片
     * @param {Object} file
     * @param {Object} fileList
     */
    handleRemove: function handleRemove(file, fileList) {
      if (file.status == 'success') {
        delete this.fileOk[file.uid];
        this.update();
      }
    },
    /**
     * 预览图片
     * @param {Object} file
     */
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    /**
     * 文件超出限制
     */
    exceed: function exceed(files, fileList) {
      this.$message.error("\u6700\u591A\u53EF\u4E0A\u4F20".concat(this.limit, "\u4E2A\u6587\u4EF6"));
    },
    update: function update() {
      var fileOk = JSON.parse(JSON.stringify(this.fileOk));
      this.$emit('fileOk', Object.values(fileOk));
    }
  }
};